import { z } from 'zod';
import { baseObjectSchema, baseSchema } from '../baseSchemas';

const materialDCSchema = baseObjectSchema.extend({
  materialID: z.string(),
  distributionChannelID: z.string(),
  recordMode: z.number().optional(),
});

const salesPersonDCSchema = baseObjectSchema.extend({
  salesPersonID: z.string(),
  distributionChannelID: z.string(),
  recordMode: z.number().optional(),
});

export const distributionChannel = baseObjectSchema.extend({
  companyID: z.string(),
  mwAccountGroupID: z.string(),
  exvan: z.boolean(),
  orders: z.boolean(),
  logistics: z.boolean(),
  uniqueTradersPerRoute: z.boolean(),
  isDefault: z.boolean(),
  company: baseSchema,
  mwAccountGroup: z.object({
    id: z.string(),
    accountGroup: z.string(),
    mwEntity: z.string(),
  }),
  materialsDC: z.array(materialDCSchema).optional(),
  salesPersonsDC: z.array(salesPersonDCSchema).optional(),
});

export const getDistributionChannelsSchema = z.array(distributionChannel);

export type GetDistributionChannelsResponse = z.infer<typeof getDistributionChannelsSchema>;
